/* eslint-disable no-useless-constructor */
import { Injectable } from '@angular/core';
import {
   CanActivateChild,
   ActivatedRouteSnapshot,
   RouterStateSnapshot,
   Router,
} from '@angular/router';
import { AppComponent } from '../app.component';
import { paths } from '../config/paths.config';

@Injectable({
   providedIn: 'root',
})
export class AdminActivateChildService implements CanActivateChild {
   constructor(private router: Router) {}

   canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
      if (AppComponent.session.rights) {
         if (AppComponent.isRight('admin')) {
            return true;
         }
         this.router.navigate([paths.home]);
         return false;
      }
      AppComponent.timeoutHandler.event.next();
      return false;
   }
}
